import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import { CountryData } from 'app/models/dto/country-data.model';
import { PhoneLocaleService } from 'app/services/phone-locale.service';
import { CountryDataState } from 'app/store/country/country-data.state';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Pipe({ name: 'phone', pure: false })
export class PhonePipe implements PipeTransform, OnDestroy {
  destroyed$ = new Subject<boolean>();

  private tenDigitPhoneLength = 10;
  private countriesData: CountryData[];

  constructor(private store: Store, private phoneLocaleService: PhoneLocaleService) {
    this.store.select(CountryDataState.countryData)
    .pipe(takeUntil(this.destroyed$)).subscribe((countryData) => {
      this.countriesData = countryData;
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
  }

  transform(number: string, phoneCountry: string = 'US'): string {
    if (number) {
      if (number.length === this.tenDigitPhoneLength) {
        if (phoneCountry === 'GB') {
          return number.replace(/(\d\d\d\d)(\d\d\d\d\d\d)/, '$1 $2');
        }
        return number.replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, '($1) $2-$3');
      } else if (number.length > this.tenDigitPhoneLength && this.countriesData) {
        // find out the country from the store
        const numberCountryCode = this.phoneLocaleService.getPhoneCountryCode(number, true);
        const numberCountryCodeId = this.getCountryNameId(numberCountryCode);
        if (number.includes('+')) {
          if (numberCountryCodeId === 'GB') {
            return number.replace(/(\d\d)(\d\d\d\d)(\d\d\d\d\d\d)/, '$1 $2 $3');
          }
          if (numberCountryCodeId === 'US') {
            return number.replace(/(\+\d)(\d\d\d)(\d\d\d)(\d\d\d\d)/, '($2) $3-$4');
          }
          return number.replace(/(\d)(\d\d\d)(\d\d\d)(\d\d\d\d)/, '$1 ($2) $3-$4');
        } else {
          if (numberCountryCodeId === 'GB') {
            return number.replace(/(\d\d)(\d\d\d\d)(\d\d\d\d\d\d)/, '+$1 $2 $3');
          } 
          if (numberCountryCodeId === 'US') {
            return number.replace(/(\d)(\d\d\d)(\d\d\d)(\d\d\d\d)/, '($2) $3-$4');
          }
          return number.replace(/(\d)(\d\d\d)(\d\d\d)(\d\d\d\d)/, '+$1 ($2) $3-$4');
        }
      }
    }
    return number;
  }

  private getCountryNameId(numberCountryCode: string): string {
    let countryNameId = '';
    this.countriesData.forEach((country) => {
      if (country.phone_country_code.countryCode.toString() === numberCountryCode) {
        countryNameId = country.countryCode ? country.countryCode : 'US';
      }
    });
    return countryNameId;
  }
}
